import { render, staticRenderFns } from "./zImg.vue?vue&type=template&id=18ddae79&scoped=true"
import script from "./zImg.vue?vue&type=script&lang=js"
export * from "./zImg.vue?vue&type=script&lang=js"
import style0 from "./zImg.vue?vue&type=style&index=0&id=18ddae79&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ddae79",
  null
  
)

export default component.exports